(() => {
  if (!window.location.pathname.includes('/cart')) return;
  
  const refreshCart = () => document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  
  if (!document.body.dataset.cartRefreshed) {
    document.body.dataset.cartRefreshed = 'true';
    setTimeout(refreshCart, 2000);
  }
  
  document.body.addEventListener('click', (e) => {
    if (!e.target) return;
    const el = e.target;
    if (!(el instanceof Element)) return;
    const btn = el.closest('button[name="minus"]') || el.closest('button[name="plus"]') || el.closest('.cart-items__remove');
    if (btn) {
      setTimeout(refreshCart, 2000);
    }
  }, true);
})();